import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../services';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { SubSink } from 'subsink';

@Component({
  selector: 'mmg-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {

  logoSrc: string = '';
  title: string = '';

  form: FormGroup;

  redirect: string;
  provider: string;
  tenantId: string;

  invalid = false;

  private readonly subs = new SubSink();

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService
  ) {
    this.logoSrc = environment.logoSrc;
    this.form = this.fb.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required, Validators.minLength(6)]]
    });
    this.redirect = '/';
    this.provider = '';
    this.tenantId = '';

    this.subs.sink = this.authService.login$
      .subscribe(result => {
        if (result) {
          this.router.navigateByUrl(this.redirect);
        } else {
          if (!this.form.pristine) {
            this.invalid = true;
          }
        }
      });
  }

  get username(): AbstractControl {
    return this.form.get('username')!;
  }

  get password(): AbstractControl {
    return this.form.get('password')!;
  }

  ngOnInit(): void {
    this.subs.sink = this.route.data
      .subscribe(data => this.title = data['title']);

    this.redirect = this.route.snapshot.queryParams['redirect'] || '/';
    this.provider = this.route.snapshot.queryParams['provider'] ?? '';
    this.tenantId = this.route.snapshot.queryParams['t'];
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  submit(): void {
    if (this.form.valid) {
      const username = this.username?.value.toLowerCase();
      const password = this.password?.value as string;
      this.authService.login({ username, password }, this.provider, this.tenantId);
    }
  }

}